import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { RiCloseCircleFill } from "react-icons/ri";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import EditClientForm from "./EditClientForm";
import ButtonUI from "../material-ui/ButtonUI";
import editClient from "../../api/editClient";
import { AuthContext } from "../../context/Auth/AuthContext";
import { EditActionButton } from "../common/ActionIconButton";
import EditIcon from "@mui/icons-material/Edit";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <RiCloseCircleFill />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const editClientFormSchema = yup.object().shape({
  name: yup.string().required("Name is required field"),
  //description: yup.string().required("Description is required field"),
  email_id: yup
    .string()
    .nullable()
    .email("Email must be valid")
    .required("Email is required field"),
  phone_number: yup
    .string()
    .nullable()
    .required("Phone Number is required field"),
  //addClientStatus: yup.string().required("Status is required field"),
  addClientType: yup
    .string()
    .nullable()
    .required("Client Type is required field"),
  addClientSubType: yup
    .string()
    .nullable()
    .required("Client Sub Type is required field"),
  // client_reference_number: yup
  //   .string()
  //   .required("Client Reference Number is required field"),
});

/*** Component for editing the client details ***/
const EditClientPopup = ({
  setClientUpdatedToTrue,
  tableValues,
  typeOptions,
  // Optional custom trigger (e.g. a labelled "Edit Client" button);
  // defaults to the existing icon button.
  renderTrigger,
}) => {
  const [open, setOpen] = useState(false);
  const { token, user_id } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editClientFormSchema),
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onEditClientFormSubmit = async (editClientFormData) => {
    setLoading(true);
    const editClientFormResponse = await editClient({
      contact_id: tableValues.contact_id,
      token: token,
      user_id: user_id,
      name: editClientFormData.name,
      description: editClientFormData.description,
      phone_number: editClientFormData.phone_number,
      // Email is read-only here: always send the client's stored email so it
      // can never be changed from this form.
      email_id: tableValues.email_id,
      //addClientStatus: editClientFormData.addClientStatus,
      addClientType: editClientFormData.addClientType,
      addClientSubType: editClientFormData.addClientSubType,
      client_reference_number: editClientFormData.client_reference_number,
      category: editClientFormData.category,
      source: "dms",
    });

    if (editClientFormResponse.code === 200) {
      setClientUpdatedToTrue();
      setOpen(false);
      setLoading(false);

      showSuccess("Client is updated successfully");
    } else {
      setLoading(false);
      showError("Error while updating client");
    }
  };

  return (
    <div className="dialog-modal">
      {renderTrigger ? renderTrigger(handleClickOpen) : <EditActionButton onClick={handleClickOpen} />}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        className="custom-edit-modal"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="edit-doc-modal"
          onClose={handleClose}
        >
          <div className="popup-header-svg-icon">
            <EditIcon />
          </div>
          <div className="popup-header-title">Edit Client</div>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <EditClientForm
            register={register}
            control={control}
            setValue={setValue}
            watch={watch}
            errors={errors}
            tableValues={tableValues}
            typeOptions={typeOptions}
          />
        </DialogContent>
        <DialogActions sx={{ paddingBottom: "15px !important" }}>
          <div className="popup_submit_btn">
            <ButtonUI
              loading={loading}
              variant="contained"
              buttonText="Submit"
              style={{
                backgroundColor: "#1a6b7c",
                boxShadow: "none",
                border: "1px solid #1a6b7c",
                fontWeight: "500",
                borderRadius: "4px",
                letterSpacing: "0.07rem",
                marginTop: "20px",
              }}
              handleSubmit={handleSubmit}
              onFormSubmit={onEditClientFormSubmit}
            />
          </div>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default EditClientPopup;
